export default "__VITE_ASSET__DSKmcS5T__"